import React from "react";
import { CHIP_COLOR_TYPES, CustomChip } from "~/components/chips/CustomChip.jsx";

// Renders a customer's custom tags as chips. Tags are free-form strings set on the customer and can be
// targeted by Price Setup rules.
export default function CustomerTagsChips({ customer, direction = "row", style }) {
    const tags = customer?.tags;
    if (!tags?.length) return null;
    return (
        <div style={{ display: "flex", flexDirection: direction, flexWrap: "wrap", gap: 4, ...style }}>
            {tags.map((tag) => (
                <CustomChip key={tag} size="small" colorType={CHIP_COLOR_TYPES.ACTION} label={tag} disableTooltip />
            ))}
        </div>
    );
}
